module.exports = __webpack_public_path__ + "modelace-postavy-liposukce_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/modelace-postavy-liposukce_1_after_tn.jpg
// module id = 1571
// module chunks = 0